import { apiServiceWrapper } from '../../../../Middleware/API/apiRequest';
import { getTokensFromStorage } from '../../../../Utils/Auth/AuthToken';
import { AUTEST_RUN_SET } from '../../../../constants/apiRoutes';
import { doubleEncode } from '../../../../Utils/Encode/UrlHelper';

/**
 * list Run Sets.
 * @returns {Promise} - A promise that resolves with the list of Run Sets or rejects with an error.
 * @param props
 */
export const listRunSet = async ({
  accessToken,
  limit,
  offset,
  filter,
  sort,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const data = {
    Filters: filter,
    pageNumber: offset === 0 ? 1 : offset,
    pageSize: limit,
    sort,
  };

  const response = await apiServiceWrapper({
    url: `${AUTEST_RUN_SET}/filter`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return {
    runSet: response.Payload,
    TotalCount: response?.TotalRecordCount,
  };
};

/**
 * Create Run Set.
 * @returns {Promise} - A promise that resolves with the creation of Run Set or rejects with an error.
 * @param data
 */
export const createRunSet = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${AUTEST_RUN_SET}`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * Update Run Set.
 * @returns {Promise} - A promise that resolves with the update of Run Set or rejects with an error.
 * @param data
 */
export const updateRunSet = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${AUTEST_RUN_SET}/${doubleEncode(data?.tenant_id)}`,
    method: 'PUT',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * delete Run Set.
 * @returns {Promise} - A promise that resolves with the update of Run Set or rejects with an error.
 * @param data
 */
export const deleteRunSet = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${AUTEST_RUN_SET}/${data?.tenant_id}?uc_ossi_run_id=${encodeURIComponent(data?.uc_ossi_run_id)}&uc_ossi_prod_id=${encodeURIComponent(data?.uc_ossi_prod_id)}&tenantid=${encodeURIComponent(data?.tenant_id)}`,
    method: 'DELETE',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * get copy Run Set.
 * @returns {Promise} - A promise that resolves with the update of Run Set or rejects with an error.
 * @param data
 */
export const getCopyRunSet = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${AUTEST_RUN_SET}/Copy?tenant_id=${data?.tenant_id}&uc_ossi_run_id=${encodeURIComponent(data?.uc_ossi_run_id)}`,
    method: 'GET',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  return response;
};
/**
 * post copy Run Set and save in DB.
 * @returns {Promise} - A promise that resolves with the create of Run Set or rejects with an error.
 * @param data
 */
export const postCopyRunSet = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${AUTEST_RUN_SET}/Copy`,
    method: 'POST',
    body: data,
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  return response;
};
